import { render, staticRenderFns } from "./Funds.vue?vue&type=template&id=13eb6db0&scoped=true&"
import script from "./Funds.vue?vue&type=script&lang=js&"
export * from "./Funds.vue?vue&type=script&lang=js&"
import style0 from "./Funds.vue?vue&type=style&index=0&id=13eb6db0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13eb6db0",
  null
  
)

export default component.exports